import styles from "./LoadingIndicator.module.css"
export default function LoadingIndicator(){
	return(
		<div className={styles.spinner}>
		  <div className={styles.cube1}></div>
		  <div className={styles.cube2}></div>
		  <div className={styles.shape}></div>
		</div>
	)
}